import { render, staticRenderFns } from "./openIdentification.vue?vue&type=template&id=6c3ddb58&scoped=true"
import script from "./openIdentification.vue?vue&type=script&lang=js"
export * from "./openIdentification.vue?vue&type=script&lang=js"
import style0 from "./openIdentification.vue?vue&type=style&index=0&id=6c3ddb58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3ddb58",
  null
  
)

export default component.exports